/**
 * Created by mIGUEL ON 22/05/2017.
 */
import { ChangeDetectionStrategy, Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { CompanyService } from '../../../services/company.service';
import { AppDataService } from '../../../services/app-data.service';
import { ExcelService } from '../../../services/excel.service';
import {UserService} from "../../../services/user.service";
import {TranslationService} from "../../../services/translation.service";
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import {Buffer} from 'buffer';
import { RecipeBean } from '../../../beansts/recipe.bean';
import {WalletService} from "../../../services/wallet.services";
import {FormBuilder, FormGroup} from "@angular/forms";
// Importando a biblioteca DXT

declare let Swal: any;
declare var $ : any;

@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  encapsulation: ViewEncapsulation.Emulated,
    selector : 'media-modal',
    templateUrl:'mediaModal.html',
    providers  : []
})
export class MediaModalComponent implements OnInit {
  public medias=[]
  public mediaKind;
  public mediaIdx;
  public itemImageTab='icon'
  public room=null;
  public image2DIdx=0;
  public livecoins=0;
  public image;
  public roomImageTab='icons'
  public selectedPack: any;
  public iaText;
  public isIA=false;
  public voices=[]
  public availablePacks;

  constructor(public fb : FormBuilder,
    public _companyService: CompanyService,public _walletService: WalletService,public translate: TranslationService,
              public _appData: AppDataService,public _excel : ExcelService,public _auth : UserService,private sanitizer: DomSanitizer) {

  }

  public ngOnInit(): void {
  }
public reload(){
  this.room=this._appData.room;

  if (this._appData.tabToEdit){
    this.itemImageTab=this._appData.tabToEdit
    this._appData.tabToEdit=null;
    let idx=this.room.textures[this.itemImageTab].length-1
    this.editMedia(idx)
  }

}
public selectAvailablePackForMedia(pack){
  this.selectedPack=pack;
  this.setMediaTab(this.itemImageTab);
}
  public editMedia(i: number) {
      let id0 = i;
      if (this.selectedPack){
        this.image = this.room.packs[this.selectedPack][this.itemImageTab][id0]; // Acesso ao array `icons`
      }
      else{
        this.image = this.room.textures[this.itemImageTab][id0]; // Acesso ao array `icons`
      }
      this.image2DIdx = id0;

      setTimeout(() => {
          $('#mediaName').val(this.image.name || '');
          $('#mediaURL').val(this.image.url || '');
          $('#mediaSpace').val(this.image.space || '');
          $('#mediaCols').val(this.image.cols || '');
          $('#mediaRows').val(this.image.rows || '');
      }, 100);

      $('#editCardMediaModal').modal('show');
  }

// background functions
public setImageTab(tab){
  this.roomImageTab=tab;
}
// item media functions
public setMediaTab(tab){
  this.itemImageTab=tab;
  if (this.room){
    if (this.selectedPack){
      let pack=this.room.packs[this.selectedPack];

        if (pack[tab]){
          this.medias=pack[tab];
        }
        else{
          this.medias=[]
        }
      

    }
    else{
      if (!this.room.textures) {
        this.room.textures={};
      }
      this.medias=this.room.textures[tab];  
      if (tab=='icons' && this.room.textures['icons']){
        this.room.textures.icons.forEach(v=>{
          if (v.i3d){
            v.i2d=v.i3d;
            delete v.i3d;
          }
        })
      }
    }
  
  }
}
/*
public resizeImage(file: File, maxWidth: number, maxHeight: number): Promise<Blob> {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = maxWidth;
      canvas.height = maxHeight;

      const ctx = canvas.getContext('2d');
      ctx.drawImage(image, 0, 0, maxWidth, maxHeight);

      canvas.toBlob((blob) => {
        if (blob) {
          resolve(blob);
        } else {
          reject(new Error('Erro ao criar Blob da imagem redimensionada.'));
        }
      }, 'image/png');
    };
    image.onerror = reject;
    image.src = URL.createObjectURL(file);
  });
}
*/
public deleteMedia(i){
  let subpaths=[]
  let self=this;
  let extension='png'
  switch (this.itemImageTab){
    case 'videos':{
      subpaths.push('url')
      break
    }
    case 'icons':{
      subpaths.push('i2d')
      break
    }
    case 'images':{
      subpaths.push('url')
      break
    }
    case 'audios':{
      subpaths.push('url')
      break
    }
    case 'animation':{
      subpaths.push('url')
      break
    }
    case 'files':{
      subpaths.push('url')
      break
    }
    case 'models':{
      subpaths.push('model')
      subpaths.push('img')
      break
    }
  }
  subpaths.forEach(subpath=>{
      let filename=self.room.textures[this.itemImageTab][i][subpath]
      if (filename){
        let extensionIdx=filename.indexOf('?')
        self.image=self.room.textures[this.itemImageTab][i];
        extension=filename.substring(filename.lastIndexOf('.')+1,extensionIdx)
        this._auth.removeFromFirestore('events/1592880902713/rooms/'+this.room.id+'/media/'+this.itemImageTab+'/'+subpath+'/'+this.image.id+'.'+extension)
      }
  })
  this.image=this.room.textures[this.itemImageTab][i]
   this.room.textures[this.itemImageTab]=this.room.textures[this.itemImageTab].filter(v=>{
      return v.id!=this.image.id
    })
    this.medias=this.room.textures[this.itemImageTab]
    this._companyService.getRoom(this.room.id).set(this.room)

  

}
public reloadItem(){
  if (this._appData.memoryItem){
    $("#editCardMediaModal").modal('hide')
    $("#itemManipulationModal").modal('show')


    this._appData.object=this._appData.memoryItem;
    this._appData.memoryItem=null
    setTimeout(()=>{
      $("#itemManipulationReload").click();
    },1000)
  }
}
public removeMedia(subpath,i){
  if (!subpath){
  switch (this.itemImageTab){
    case 'videos':{
      subpath=('url')
      break
    }
    case 'icons':{
      subpath=('i2d')
      break
    }
    case 'images':{
      subpath=('url')
      break
    }
    case 'audios':{
      subpath=('url')
      break
    }
    case 'animation':{
      subpath=('url')
      break
    }
    case 'files':{
      subpath=('url')
      break
    }

    }
  }
    let self=this;
      let filename=self.room.textures[this.itemImageTab][i][subpath]
      let extensionIdx=filename.indexOf('?')
      self.image=self.room.textures[this.itemImageTab][i];
      let extension=filename.substring(filename.lastIndexOf('.')+1,extensionIdx)
      this._auth.removeFromFirestore('events/1592880902713/rooms/'+this.room.id+'/media/'+this.itemImageTab+'/'+subpath+'/'+this.image.id+'.'+extension).then(snapshot =>{
          if (this.selectedPack){
            this.room.packs[this.selectedPack][this.itemImageTab][i][subpath]=''
            this.medias=this.room.packs[this.selectedPack][this.itemImageTab]

          }
          else{
            this.room.textures[this.itemImageTab][i][subpath]=''
            this.medias=this.room.textures[this.itemImageTab]
          }
          this.image=this.medias[i]
          this._companyService.getRoom(this.room.id).set(this.room)

        }).catch(err=>{
          if (err.code=='storage/object-not-found'){
            if (this.selectedPack){
              this.room.packs[this.selectedPack][this.itemImageTab][i][subpath]=''
              this.medias=this.room.packs[this.selectedPack][this.itemImageTab]
              this.image=this.medias[i]
            }
            else{
              this.medias[i][subpath]=''
              this.image=this.medias[i]
              this.room.textures[this.itemImageTab][i][subpath]=''
            }
            this._companyService.getRoom(this.room.id).set(this.room)
            }
        })

  

}
public addMediaEdit(kind){
  this.mediaKind=kind;
  this.mediaIdx=this.image2DIdx;
  if (kind=='img'){
    $('#mediaUploadermodelicons').click();
  }
  else{
    $('#mediaUploader'+this.itemImageTab).click();
  }
}
public addMedia(){
  this.mediaKind=null;
  this.mediaIdx=null;
  $('#mediaUploader'+this.itemImageTab).click();
}
public uploadRoomMedia(fileInput: any) {
  let validExtensions: string[] = [];
  if (this.mediaKind) {
    //apenas para modelos que podem ter imagens e modelos
    if (this.mediaKind === 'model') {
      validExtensions = ['fbx', 'glb'];
    } else if (this.mediaKind === 'img') {
      validExtensions = ['png','jpg'];
    }


  } else {
    //media kind ==null
    //adicionando multiplos sem media type pre-definido
    if (this.itemImageTab === 'images') {
      validExtensions = ['png','jpg'];
      this.mediaKind = 'url';
    }
    if (this.itemImageTab === 'audios') {
      validExtensions = ['mp3'];
      this.mediaKind = 'url';
    }
    if (this.itemImageTab === 'videos') {
      validExtensions = ['mp4'];
      this.mediaKind = 'url';
    }
    if (this.itemImageTab === 'icons') {
      validExtensions = ['png','jpg'];
      this.mediaKind = 'i2d';
    }
    if (this.itemImageTab === 'models') {
      //para modelo começa-se adicionando as imagens dos modelos.
      validExtensions = ['fbx', 'glb'];
      this.mediaKind = 'model';
    }
    if (this.itemImageTab === 'files') {
      validExtensions = ['pdf','pptx','ppt'];
      this.mediaKind = 'url';
    }
  }
  if (!this.room.textures[this.itemImageTab]){
    this.room.textures[this.itemImageTab]=[]
  }

  let counter=0
  let fileArray=Array.from(fileInput.target.files)
  this.medias=this.room.textures[this.itemImageTab];
  if (!this.medias){this.medias=[]}
  if (this.mediaIdx==null){
    let newarray= new Array(fileArray.length).fill(null).map(() => ({ url: '' }));
    this.mediaIdx=this.room.textures[this.itemImageTab].length;
    newarray.forEach((v,i)=>{
      this.medias.push(v);
    })
  }
  let date=new Date();
  let milis=date.getTime();
  let organizator={};
  fileArray.forEach((file:File)=>{
    counter++;
    const fileName = file.name;
    const fileExtension = fileName.split('.').pop();

    // Verificar se a extensão do arquivo é permitida
    if (!validExtensions.includes(fileExtension.toLowerCase())) {
      alert('Por favor, selecione um arquivo com a extensão válida: ' + validExtensions.join(', '));
      return;
    }

    milis++
    let newfile = (milis) + '.' + fileExtension;
    organizator[(milis)]={idx:(this.mediaIdx),name:fileName};
    Swal.fire({
      title: this.translate.instant('WAIT'),
      text: this.translate.instant('PROCESSING_TRANSFER'),
      imageUrl: "https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/gameImages%2Ftransfer.gif?alt=media&token=67c0bdef-76b4-40e5-8fdb-65501ef94aff",
      showConfirmButton: false
    });


      // Não é uma imagem PNG, provavelmente é um modelo FBX ou um video mp4
      this._auth.uploadToFirebase(file, newfile, 'events/1592880902713/rooms/' + this.room.id + '/media/' + this.itemImageTab + '/' +this.mediaKind ).subscribe(snapshot => {
        snapshot.ref.getDownloadURL().then(url => {
          counter--
          let fileIndex=newfile.split('.')[0];
          let index=organizator[fileIndex].idx
          let obj=this.medias[index];
          if (!obj.id){
            obj['id']=fileIndex
          }
          obj[this.mediaKind]=url;
          obj['name']=organizator[fileIndex].name;
          obj['uploaded']=true;
          this.medias[index]=obj
              if (counter==0){
                this.reloadItem();
                this.room.textures[this.itemImageTab] = this.medias;
                this.image = this.medias[index];
                this._companyService.getRoom(this.room.id).set(this.room);
                Swal.close();
              }

        });
      });
    
    this.mediaIdx++;
  });
}
  

public updateMediaURL(){
  let dtex=document.getElementById('mediaURL')
  let tex=dtex['value'];
  this.room.textures[this.itemImageTab][this.image2DIdx].url = tex;
  this._companyService.getRooms().doc(this.room.id).set(this.room);
}
public updateMediaName2(){
  let dtex=document.getElementById('mediaName')
  let tex=dtex['value'];
  this.room.textures[this.itemImageTab][this.image2DIdx].name = tex;
  this._companyService.getRooms().doc(this.room.id).set(this.room);
}
  public sendIframeMessage(messageKind) {
    let frame = 'gameFrame'
    if (this._appData.focusIframe) {
      frame = this._appData.focusIframe;
    }
    var iframe = document.getElementById(frame);
    if (iframe == null) return;
    var iWindow = (<HTMLIFrameElement>iframe).contentWindow;
    iWindow.postMessage(messageKind, "*");
  }

public getBalance(){
  this._walletService.getTokenBalance('company',this._appData.company.dbId).subscribe(val=>{
    let vet=val.json();
    vet.forEach(element => {
      let address=element.mint_address
      let amount=element.ui_amount
      if (address=='BmHvLKAGRd2o3WKm2U7u7qaJoAjzqCQfzLyUVrFznmuu'){//livecoin
          this.livecoins=amount;
      }
    })
  })

}


  public updateMediaName(what) {

    if (!this.image) {
        return;
    }

    if (what === 'cols') {
        this.image.cols = parseInt($('#mediaCols').val());
    }

    if (what === 'rows') {
        this.image.rows = parseInt($('#mediaRows').val());
    }

    this._companyService.getRooms().doc(this.room.id).set(this.room);
}


  public setMediaTabContent(tab){
    this.itemContentImageTab=tab;
    if (tab.indexOf('IA')>=0){
      this.isIA=true;
    }
    else{
      this.isIA=false;
    }
    if (tab=='voiceIA'){
      if (!this.voices || this.voices.length==0){
        this.getVoices();        
      }
    }
    if (tab=='avatarIA'){
      if (!this.voices || this.voices.length==0){
        this.getHeyGenVoices();        
        this.getHeyGenAvatars();        
      }
    }
 
    this.searchResults=[];
  }
  public setFetchHeyGenResults(videoId){
              Swal.fire({
            title: this.translate.instant('WAIT'),
            text: this.translate.instant('PROCESSING_TRANSFER'),
            imageUrl: "https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/gameImages%2Ftransfer.gif?alt=media&token=67c0bdef-76b4-40e5-8fdb-65501ef94aff",
            showConfirmButton: false
          });    

    let interval=setInterval(()=>{
      this._companyService.getHeyGenVideoStatus(videoId).subscribe(res=>{
        let vet=res.json();
        let data=vet.data;
        if (data.status=='completed'){
          this.searchResults=[]
          this.searchResults.push({id:videoId,src:data.video_url,titulo:'generated',tags:[]})
          clearInterval(interval)
          Swal.close();
        }
        
      })
    },10000)

  }
  public search(){
        let kind='';
        let page=this.page
        if (!page){page=1;}
        let file=false;
        if (!this.isIA){
          if (this.itemImageTab=='icons'){
            kind='iconSearch'
          }
          else if (this.itemImageTab=='models' ){
            kind='iconSearch'
          }          
          else if (this.itemImageTab=='images'){
            kind='imagesSearch'
          }
          else if (this.itemImageTab=='audios' ){
            kind='soundSearch'
          }
          else if (this.itemImageTab=='videos' ){
            kind='videoSearch'
          }
        }
        else{
          kind=this.itemContentImageTab
          if (this.itemImageTab=='audios' ){
            file=true;
          }
        }

        let campoBusca = (document.getElementById('campoBusca') as HTMLInputElement).value;
        let imagens = [];
        let args=null;
        if (this.voice){
          args={voice:this.voice.voice_id}
        }
        if (this.avatar){
          if (!args){args={};}
          args['avatar']=this.avatar.avatar_id
        }
        if (page){
          if (!args){args={};}
          args['page']=page;
        }

        this._companyService.getIconsFromSearch(campoBusca,kind,file,args).subscribe((response) => {
          let vet=null;
          if (file){
            try{
            this.base64File = response['_body']; // 👈 convert to Blob
            }
            catch(e){
              this.base64File = response;//new Blob([response], { type: 'audio/mpeg' });
            }
            vet = URL.createObjectURL(this.base64File );
          }
          else{
            vet=response.json();
          }
          if (this.itemImageTab=='icons' || this.itemImageTab=='images' || this.itemImageTab=='models'){

            let array=vet.data;
            if (array.task_id){
              this.taskId=array.task_id;
              this.setWebHookResults();
            }

            array.forEach(v=>{
              if (v.thumbnails && v.thumbnails.length>0){
                //icons
                imagens.push({id:v.id.toString(),src:v.thumbnails[0].url,titulo:v.name,tags:v.tags})
              }
              else{
                //images
                imagens.push({id:v.id.toString(),src:v.image.source.url,titulo:v.title,tags:v.tags})

              }
            })
          }
          if (this.itemImageTab=='videos'){
            let array=vet.data;
            if (array.task_id){
              this.taskId=array.task_id;
              this.setWebHookResults();
            }
            if (array.video_id){
              
              this.setFetchHeyGenResults(array.video_id)
            }

            array.forEach(v=>{
                imagens.push({id:v.id,src:v.previews[0].url,titulo:v.name,tags:v.tags})
            })
          }          
          if (this.itemImageTab=='audios'){
            if (this.isIA){
              let sanvet=this.sanitizer.bypassSecurityTrustUrl(vet);
              imagens.push({id:'iaGeneratorFile',src:sanvet,titulo:campoBusca,tags:[]})
            }
            else{
              let array=vet.results;   
              array.forEach(v=>{
                    let preview=v.previews['preview-hq-mp3'] || v.previews['preview-lq-mp3']
                    if (preview){
                      imagens.push({id:v.id,src:preview,titulo:v.name,tags:v.tags})
                    }
              })                     
            }
          }
          this.searchResults=imagens;
        })
  }
  public setWebHookResults(){
          Swal.fire({
            title: this.translate.instant('WAIT'),
            text: this.translate.instant('PROCESSING_TRANSFER'),
            imageUrl: "https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/gameImages%2Ftransfer.gif?alt=media&token=67c0bdef-76b4-40e5-8fdb-65501ef94aff",
            showConfirmButton: false
          });    
    this.snapshot=this._companyService.getRoomIASnapshot(this.taskId).onSnapshot((querySnapshot)=>{
      let iaResults=querySnapshot.data();
      this.searchResults=[]
      let time=new Date().getTime();
      if (iaResults.generated && iaResults.generated.length>0){
        Swal.close();
        iaResults.generated.forEach(v=>{
          time++;
          this.searchResults.push({id:time,src:v,titulo:'generated',tags:[]})
        })
      }
    })
  }
  public useVoice(voice){
    this.voice=voice;
    this.voices.forEach(v=>{v.selected=false;})
    voice.selected=true;
  }
  public getVoices(){
    this._companyService.getVoices().subscribe(res=>{
      let vet=res.json();
      this.voices=vet.voices;
    })
  }
  public useAvatar(avatar){
    this.avatar=avatar;
    this.avatars.forEach(v=>{v.selected=false;})
    avatar.selected=true;
  }
 
  public getHeyGenVoices(){
    this._companyService.getHeyGenVoices().subscribe(res=>{
      let vet=res.json();
      this.allVoices=vet.data.voices
      this.voices=vet.data.voices.slice(0, 10);;
    })
  }
    public getHeyGenAvatars(){
    this._companyService.getHeyGenAvatars().subscribe(res=>{
      let vet=res.json();
      this.allAvatars=vet.data.avatars;
      this.avatars=vet.data.avatars.slice(0, 10);;
    })
  }  
  public usePick(pick){
    let subpath='';
    this.searchResults.forEach(v=>{v.selected=false;})
    pick.selected=true;
    switch (this.itemImageTab){
      case 'icons':{
        subpath='i2d'
        break
      }
      case 'models':{
        subpath='img'
        break
      }
    }
    if (!subpath){
      subpath='url';
    }
    //remove file if its on my storage
    if (this.image.uploaded){
      this.image.uploaded=false;
      let extension=this.findExtention(this.image[subpath]);
      this._auth.removeFromFirestore('events/1592880902713/rooms/'+this.room.id+'/media/'+this.itemImageTab+'/'+subpath+'/'+this.image.id+'.'+extension)
    }
    if (pick.titulo!='generated'){
      this.image[subpath]=pick.src;
      this.image.name=pick.titulo;
      //just use the src
    }
    if (pick.id.indexOf('iaGeneratorFile')>=0){
      //its a generated file;
      let blob=this.base64File;//new Blob([this.base64File], { type: 'audio/mpeg' });
      let date=new Date();
      let milis=date.getTime();
      this._auth.uploadToFirebase(blob, milis+'.mp3', 'events/1592880902713/rooms/' + this.room.id + '/media/' + this.itemImageTab + '/'+subpath ).subscribe(snapshot => {
              snapshot.ref.getDownloadURL().then(url => {
                let obj={}
                obj[subpath]=url;
                obj['id']=milis
                obj['uploaded']=true;
                this.medias[this.image2DIdx]=obj
                this.room.textures[this.itemImageTab] = this.medias;
                this.image = obj;
                this.reloadItem();
                this._companyService.getRoom(this.room.id).set(this.room);
                Swal.close();

              });
            });
    }
    else{
      //its a generated image, so we need to download and reupload to my storage
      let self=this;
      this.fetch(pick.src,subpath)
      return
    }
    this._appData.room.textures[this.itemImageTab][this.image2DIdx]=this.image;
    this._companyService.getRoom(this.room.id).set(this._appData.room);
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }
  public findExtention(url){
        let filename=url
        let extensionIdx=filename.indexOf('?')
        return filename.substring(filename.lastIndexOf('.')+1,extensionIdx)
  }
  public fetch(externalLink,subpath){
    let self=this;
    this._companyService.downloadBlob(externalLink,subpath).subscribe(res =>{
              self.image[subpath]=JSON.parse(res['_body'])[0];
              let url=self.image[subpath];
              let extensionIdx=url.indexOf('?')
              let subpathudx=url.indexOf(subpath)+subpath.length+1;
              let filename=url.substring(subpathudx,extensionIdx)
              self.image.id=filename;
              self.image.uploaded=true;
              this._appData.room.textures[this.itemImageTab][this.image2DIdx]=this.image;
              this.reloadItem();
              this._companyService.getRoom(this.room.id).set(this._appData.room);
              window.scrollTo({
                top: 0,
                behavior: "smooth"
              });
    })
  }
  public back(){
    this.page=this.page-1;
    if (this.page==0){
      this.page=1;
    }
    this.pages=[this.page,this.page+1,this.page+2,this.page+3]
    this.search()

  }
  public next(){
    this.page=this.page+1;
    this.pages=[this.page-1,this.page,this.page+1,this.page+2]
    this.search()
  }
  public gotoPage(page){
    this.page=page;
    if (this.page<2){
      this.pages=[1,2,3,4]
    }
    else{
      this.pages=[this.page-1,this.page,this.page+1,this.page+2]
    }
    this.search()
  }
  public page=1;
  public pages=[1,2,3,4];
  public searchResults=[]
  public itemContentImageTab='search'
  public snapshot:any;
  public taskId='';
  public base64File;
  public voice;
  public avatars=[];
  public avatar;



    public back2(){
    this.page2=this.page2-1;
    if (this.page2==0){
      this.page2=1;
    }
    this.pages2=[this.page2,this.page2+1,this.page2+2,this.page2+3]
    this.avatars=this.allAvatars.splice((this.page2-1)*10+1,10)

  }
  public next2(){
    this.page2=this.page2+1;
    this.pages2=[this.page2-1,this.page2,this.page2+1,this.page2+2]
    this.avatars=this.allAvatars.splice((this.page2-1)*10+1,10)
  }
  public gotoPage2(page){
    this.page2=page;
    if (this.page2<2){
      this.pages2=[1,2,3,4]
    }
    else{
      this.pages2=[this.page2-1,this.page2,this.page2+1,this.page2+2]
    }
    this.avatars=this.allAvatars.splice((this.page2-1)*10+1,10)
  }
  public page2=1;
  public pages2=[1,2,3,4];
  public back3(){
    this.page3=this.page3-1;
    if (this.page3==0){
      this.page3=1;
    }
    this.pages3=[this.page3,this.page3+1,this.page3+2,this.page3+3]
    this.voices=this.allVoices.splice((this.page3-1)*10+1,10)
  }
  public next3(){
    this.page3=this.page3+1;
    this.pages3=[this.page3-1,this.page3,this.page3+1,this.page3+2]
    this.voices=this.allVoices.splice((this.page3-1)*10+1,10)
  }
  public gotoPage3(page){
    this.page3=page;
    if (this.page3<2){
      this.pages3=[1,2,3,4]
    }
    else{
      this.pages3=[this.page3-1,this.page3,this.page3+1,this.page3+2]
    }
    this.voices=this.allVoices.splice((this.page3-1)*10+1,10)
  }
  public page3=1;
  public pages3=[1,2,3,4];

  public allVoices;
  public allAvatars;
}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/mediaModal/mediaModal.ts